import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { ThemeProvider, ToastProvider, TooltipProvider } from "@codelittinc/carbon-design-system";
import { App } from "./App";
import { forgetHandbookQuestionAway } from "./lib/signin";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");

forgetHandbookQuestionAway(window.location.pathname, () => window.sessionStorage);

createRoot(root).render(
  <StrictMode>
    <ThemeProvider>
      <ToastProvider>
        <TooltipProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </TooltipProvider>
      </ToastProvider>
    </ThemeProvider>
  </StrictMode>,
);
